export default {
  // TODO:authority: ['zhiyuan-special-college', 'zhiyuan-special-major', 'zhiyuan-special-profession', 'zhiyuan-special-index', 'zhiyuan-special-career-plan', 'zhiyuan-special-volunteer-questions', 'zhiyuan-article-index', 'zhiyuan-article-college', 'zhiyuan-article-major', 'zhiyuan-article-profession', 'zhiyuan-article-career-plan', 'zhiyuan-article-volunteer-questions', 'zhiyuan-banner-index', 'zhiyuan-banner-career-plan', 'volunteer-card', 'volunteer-use', 'xuanke-special-list', 'xuanke-article-list', 'xuanke-topic-list', 'feedback-list', 'order', 'system-authority', 'system-user', 'system-super-user']
  authority: [],
  tagView: [{
    name: '首页',
    path: '/index'
  }],
  breadcrumbs: []
}



// WEBPACK FOOTER //
// ./src/store/state.js